import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "../../../../types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "../../../../services/iconService";

const IconLicencePointsNine = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <path
          d="M29.485,287.126c-9.121-0.031-16.556-7.467-16.586-16.576V65.908c0-1.906,1.547-3.453,3.455-3.453
			c1.906,0,3.453,1.547,3.453,3.453v204.631c0.018,5.314,4.363,9.662,9.688,9.68h241.006c5.321-0.014,9.672-4.359,9.688-9.689
			V29.462c-0.018-5.318-4.367-9.666-9.697-9.68H29.496c-5.325,0.018-9.672,4.363-9.688,9.689v13.246
			c0,1.908-1.547,3.455-3.453,3.455c-1.908,0-3.455-1.547-3.455-3.455V29.46c0.03-9.117,7.459-16.551,16.563-16.586
			c0.008,0,0.017,0,0.022,0h241.018c9.126,0.021,16.566,7.457,16.598,16.576v241.088c-0.03,9.129-7.472,16.564-16.588,16.588H29.485
			z"
        />
        <path
          d="M149.636,169.736c3.379,0,5.939-0.318,8.469-0.809l-20.568,36.51h16.509l30.931-54.91
			c2.811-5.41,4.239-11.6,4.239-18.391c0-22.51-15.899-37.627-39.578-37.627h-0.069c-23.562,0-38.779,14.77-38.779,37.627
			C110.786,154.626,126.405,169.736,149.636,169.736z M149.745,107.208c15.719,0,26.279,10.02,26.279,24.918
			c0,6.461-1.961,12.16-5.69,16.48c-4.681,5.438-11.989,8.43-20.589,8.43c-15.66,0-25.779-9.779-25.779-24.91
			C123.965,116.988,134.065,107.208,149.745,107.208z"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.564H33.874c-1.907,0-3.454-1.547-3.454-3.455c0-1.906,1.547-3.453,3.454-3.453H262.67V33.847
			c0-1.906,1.547-3.453,3.454-3.453s3.454,1.547,3.454,3.453v232.262C269.578,268.017,268.03,269.564,266.124,269.564z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsNine;
